"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgDeleteWrapperMappingResponse = exports.MsgDeleteWrapperMapping = exports.MsgSetWrapperMappingResponse = exports.MsgSetWrapperMapping = exports.MsgLockResponse = exports.MsgLock = exports.MsgBindResponse = exports.MsgBind = exports.MsgCreateResponse = exports.MsgCreate = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "Switcheo.carbon.lockproxy";
const baseMsgCreate = { creator: "" };
exports.MsgCreate = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreate);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgCreate);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgCreate);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseMsgCreateResponse = {};
exports.MsgCreateResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgCreateResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgCreateResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgCreateResponse);
        return message;
    },
};
const baseMsgBind = {
    creator: "",
    denom: "",
    nativeChainId: long_1.default.UZERO,
};
exports.MsgBind = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.lockProxyHash.length !== 0) {
            writer.uint32(26).bytes(message.lockProxyHash);
        }
        if (!message.nativeChainId.isZero()) {
            writer.uint32(32).uint64(message.nativeChainId);
        }
        if (message.nativeLockProxyHash.length !== 0) {
            writer.uint32(42).bytes(message.nativeLockProxyHash);
        }
        if (message.nativeAssetHash.length !== 0) {
            writer.uint32(50).bytes(message.nativeAssetHash);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBind);
        message.lockProxyHash = new Uint8Array();
        message.nativeLockProxyHash = new Uint8Array();
        message.nativeAssetHash = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.lockProxyHash = reader.bytes();
                    break;
                case 4:
                    message.nativeChainId = reader.uint64();
                    break;
                case 5:
                    message.nativeLockProxyHash = reader.bytes();
                    break;
                case 6:
                    message.nativeAssetHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgBind);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.lockProxyHash =
            object.lockProxyHash !== undefined && object.lockProxyHash !== null
                ? bytesFromBase64(object.lockProxyHash)
                : new Uint8Array();
        message.nativeChainId =
            object.nativeChainId !== undefined && object.nativeChainId !== null
                ? long_1.default.fromString(object.nativeChainId)
                : long_1.default.UZERO;
        message.nativeLockProxyHash =
            object.nativeLockProxyHash !== undefined &&
                object.nativeLockProxyHash !== null
                ? bytesFromBase64(object.nativeLockProxyHash)
                : new Uint8Array();
        message.nativeAssetHash =
            object.nativeAssetHash !== undefined && object.nativeAssetHash !== null
                ? bytesFromBase64(object.nativeAssetHash)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.lockProxyHash !== undefined &&
            (obj.lockProxyHash = base64FromBytes(message.lockProxyHash !== undefined
                ? message.lockProxyHash
                : new Uint8Array()));
        message.nativeChainId !== undefined &&
            (obj.nativeChainId = (message.nativeChainId || long_1.default.UZERO).toString());
        message.nativeLockProxyHash !== undefined &&
            (obj.nativeLockProxyHash = base64FromBytes(message.nativeLockProxyHash !== undefined
                ? message.nativeLockProxyHash
                : new Uint8Array()));
        message.nativeAssetHash !== undefined &&
            (obj.nativeAssetHash = base64FromBytes(message.nativeAssetHash !== undefined
                ? message.nativeAssetHash
                : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseMsgBind);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.lockProxyHash = (_c = object.lockProxyHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.nativeChainId =
            object.nativeChainId !== undefined && object.nativeChainId !== null
                ? long_1.default.fromValue(object.nativeChainId)
                : long_1.default.UZERO;
        message.nativeLockProxyHash =
            (_d = object.nativeLockProxyHash) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.nativeAssetHash = (_e = object.nativeAssetHash) !== null && _e !== void 0 ? _e : new Uint8Array();
        return message;
    },
};
const baseMsgBindResponse = {};
exports.MsgBindResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgBindResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgBindResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgBindResponse);
        return message;
    },
};
const baseMsgLock = {
    denom: "",
    fromAddress: "",
    toChainId: long_1.default.UZERO,
    amount: "",
    deductFeeInLock: false,
    feeAmount: "",
    feeAddress: "",
};
exports.MsgLock = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.fromLockProxy.length !== 0) {
            writer.uint32(18).bytes(message.fromLockProxy);
        }
        if (message.fromAddress !== "") {
            writer.uint32(26).string(message.fromAddress);
        }
        if (message.fromAssetId.length !== 0) {
            writer.uint32(34).bytes(message.fromAssetId);
        }
        if (!message.toChainId.isZero()) {
            writer.uint32(40).uint64(message.toChainId);
        }
        if (message.toLockProxy.length !== 0) {
            writer.uint32(50).bytes(message.toLockProxy);
        }
        if (message.toAssetId.length !== 0) {
            writer.uint32(58).bytes(message.toAssetId);
        }
        if (message.toAddress.length !== 0) {
            writer.uint32(66).bytes(message.toAddress);
        }
        if (message.amount !== "") {
            writer.uint32(74).string(message.amount);
        }
        if (message.deductFeeInLock === true) {
            writer.uint32(80).bool(message.deductFeeInLock);
        }
        if (message.feeAmount !== "") {
            writer.uint32(90).string(message.feeAmount);
        }
        if (message.feeAddress !== "") {
            writer.uint32(98).string(message.feeAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLock);
        message.fromLockProxy = new Uint8Array();
        message.fromAssetId = new Uint8Array();
        message.toLockProxy = new Uint8Array();
        message.toAssetId = new Uint8Array();
        message.toAddress = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.fromLockProxy = reader.bytes();
                    break;
                case 3:
                    message.fromAddress = reader.string();
                    break;
                case 4:
                    message.fromAssetId = reader.bytes();
                    break;
                case 5:
                    message.toChainId = reader.uint64();
                    break;
                case 6:
                    message.toLockProxy = reader.bytes();
                    break;
                case 7:
                    message.toAssetId = reader.bytes();
                    break;
                case 8:
                    message.toAddress = reader.bytes();
                    break;
                case 9:
                    message.amount = reader.string();
                    break;
                case 10:
                    message.deductFeeInLock = reader.bool();
                    break;
                case 11:
                    message.feeAmount = reader.string();
                    break;
                case 12:
                    message.feeAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgLock);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.fromLockProxy =
            object.fromLockProxy !== undefined && object.fromLockProxy !== null
                ? bytesFromBase64(object.fromLockProxy)
                : new Uint8Array();
        message.fromAddress =
            object.fromAddress !== undefined && object.fromAddress !== null
                ? String(object.fromAddress)
                : "";
        message.fromAssetId =
            object.fromAssetId !== undefined && object.fromAssetId !== null
                ? bytesFromBase64(object.fromAssetId)
                : new Uint8Array();
        message.toChainId =
            object.toChainId !== undefined && object.toChainId !== null
                ? long_1.default.fromString(object.toChainId)
                : long_1.default.UZERO;
        message.toLockProxy =
            object.toLockProxy !== undefined && object.toLockProxy !== null
                ? bytesFromBase64(object.toLockProxy)
                : new Uint8Array();
        message.toAssetId =
            object.toAssetId !== undefined && object.toAssetId !== null
                ? bytesFromBase64(object.toAssetId)
                : new Uint8Array();
        message.toAddress =
            object.toAddress !== undefined && object.toAddress !== null
                ? bytesFromBase64(object.toAddress)
                : new Uint8Array();
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.deductFeeInLock =
            object.deductFeeInLock !== undefined && object.deductFeeInLock !== null
                ? Boolean(object.deductFeeInLock)
                : false;
        message.feeAmount =
            object.feeAmount !== undefined && object.feeAmount !== null
                ? String(object.feeAmount)
                : "";
        message.feeAddress =
            object.feeAddress !== undefined && object.feeAddress !== null
                ? String(object.feeAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.fromLockProxy !== undefined &&
            (obj.fromLockProxy = base64FromBytes(message.fromLockProxy !== undefined
                ? message.fromLockProxy
                : new Uint8Array()));
        message.fromAddress !== undefined &&
            (obj.fromAddress = message.fromAddress);
        message.fromAssetId !== undefined &&
            (obj.fromAssetId = base64FromBytes(message.fromAssetId !== undefined
                ? message.fromAssetId
                : new Uint8Array()));
        message.toChainId !== undefined &&
            (obj.toChainId = (message.toChainId || long_1.default.UZERO).toString());
        message.toLockProxy !== undefined &&
            (obj.toLockProxy = base64FromBytes(message.toLockProxy !== undefined
                ? message.toLockProxy
                : new Uint8Array()));
        message.toAssetId !== undefined &&
            (obj.toAssetId = base64FromBytes(message.toAssetId !== undefined ? message.toAssetId : new Uint8Array()));
        message.toAddress !== undefined &&
            (obj.toAddress = base64FromBytes(message.toAddress !== undefined ? message.toAddress : new Uint8Array()));
        message.amount !== undefined && (obj.amount = message.amount);
        message.deductFeeInLock !== undefined &&
            (obj.deductFeeInLock = message.deductFeeInLock);
        message.feeAmount !== undefined && (obj.feeAmount = message.feeAmount);
        message.feeAddress !== undefined && (obj.feeAddress = message.feeAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = Object.assign({}, baseMsgLock);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.fromLockProxy = (_b = object.fromLockProxy) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.fromAddress = (_c = object.fromAddress) !== null && _c !== void 0 ? _c : "";
        message.fromAssetId = (_d = object.fromAssetId) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.toChainId =
            object.toChainId !== undefined && object.toChainId !== null
                ? long_1.default.fromValue(object.toChainId)
                : long_1.default.UZERO;
        message.toLockProxy = (_e = object.toLockProxy) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.toAssetId = (_f = object.toAssetId) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.toAddress = (_g = object.toAddress) !== null && _g !== void 0 ? _g : new Uint8Array();
        message.amount = (_h = object.amount) !== null && _h !== void 0 ? _h : "";
        message.deductFeeInLock = (_j = object.deductFeeInLock) !== null && _j !== void 0 ? _j : false;
        message.feeAmount = (_k = object.feeAmount) !== null && _k !== void 0 ? _k : "";
        message.feeAddress = (_l = object.feeAddress) !== null && _l !== void 0 ? _l : "";
        return message;
    },
};
const baseMsgLockResponse = {};
exports.MsgLockResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgLockResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgLockResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgLockResponse);
        return message;
    },
};
const baseMsgSetWrapperMapping = {
    creator: "",
    chainId: long_1.default.UZERO,
    fromContractAddress: "",
    toContractAddress: "",
    lockType: long_1.default.UZERO,
};
exports.MsgSetWrapperMapping = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(16).uint64(message.chainId);
        }
        if (message.fromContractAddress !== "") {
            writer.uint32(26).string(message.fromContractAddress);
        }
        if (message.toContractAddress !== "") {
            writer.uint32(34).string(message.toContractAddress);
        }
        if (!message.lockType.isZero()) {
            writer.uint32(40).uint64(message.lockType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetWrapperMapping);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.uint64();
                    break;
                case 3:
                    message.fromContractAddress = reader.string();
                    break;
                case 4:
                    message.toContractAddress = reader.string();
                    break;
                case 5:
                    message.lockType = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetWrapperMapping);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.fromContractAddress =
            object.fromContractAddress !== undefined &&
                object.fromContractAddress !== null
                ? String(object.fromContractAddress)
                : "";
        message.toContractAddress =
            object.toContractAddress !== undefined &&
                object.toContractAddress !== null
                ? String(object.toContractAddress)
                : "";
        message.lockType =
            object.lockType !== undefined && object.lockType !== null
                ? long_1.default.fromString(object.lockType)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.fromContractAddress !== undefined &&
            (obj.fromContractAddress = message.fromContractAddress);
        message.toContractAddress !== undefined &&
            (obj.toContractAddress = message.toContractAddress);
        message.lockType !== undefined &&
            (obj.lockType = (message.lockType || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgSetWrapperMapping);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.fromContractAddress = (_b = object.fromContractAddress) !== null && _b !== void 0 ? _b : "";
        message.toContractAddress = (_c = object.toContractAddress) !== null && _c !== void 0 ? _c : "";
        message.lockType =
            object.lockType !== undefined && object.lockType !== null
                ? long_1.default.fromValue(object.lockType)
                : long_1.default.UZERO;
        return message;
    },
};
const baseMsgSetWrapperMappingResponse = {};
exports.MsgSetWrapperMappingResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetWrapperMappingResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetWrapperMappingResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetWrapperMappingResponse);
        return message;
    },
};
const baseMsgDeleteWrapperMapping = {
    creator: "",
    chainId: long_1.default.UZERO,
    contractAddress: "",
};
exports.MsgDeleteWrapperMapping = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(16).uint64(message.chainId);
        }
        if (message.contractAddress !== "") {
            writer.uint32(26).string(message.contractAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteWrapperMapping);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.uint64();
                    break;
                case 3:
                    message.contractAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgDeleteWrapperMapping);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        message.contractAddress =
            object.contractAddress !== undefined && object.contractAddress !== null
                ? String(object.contractAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        message.contractAddress !== undefined &&
            (obj.contractAddress = message.contractAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgDeleteWrapperMapping);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        message.contractAddress = (_b = object.contractAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseMsgDeleteWrapperMappingResponse = {};
exports.MsgDeleteWrapperMappingResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgDeleteWrapperMappingResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgDeleteWrapperMappingResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgDeleteWrapperMappingResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Create = this.Create.bind(this);
        this.Bind = this.Bind.bind(this);
        this.Lock = this.Lock.bind(this);
        this.SetWrapperMapping = this.SetWrapperMapping.bind(this);
        this.DeleteWrapperMapping = this.DeleteWrapperMapping.bind(this);
    }
    Create(request) {
        const data = exports.MsgCreate.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.lockproxy.Msg", "Create", data);
        return promise.then((data) => exports.MsgCreateResponse.decode(new minimal_1.default.Reader(data)));
    }
    Bind(request) {
        const data = exports.MsgBind.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.lockproxy.Msg", "Bind", data);
        return promise.then((data) => exports.MsgBindResponse.decode(new minimal_1.default.Reader(data)));
    }
    Lock(request) {
        const data = exports.MsgLock.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.lockproxy.Msg", "Lock", data);
        return promise.then((data) => exports.MsgLockResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetWrapperMapping(request) {
        const data = exports.MsgSetWrapperMapping.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.lockproxy.Msg", "SetWrapperMapping", data);
        return promise.then((data) => exports.MsgSetWrapperMappingResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeleteWrapperMapping(request) {
        const data = exports.MsgDeleteWrapperMapping.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.lockproxy.Msg", "DeleteWrapperMapping", data);
        return promise.then((data) => exports.MsgDeleteWrapperMappingResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
